import { render, staticRenderFns } from "./PrenesiNalozenoDatoteko.vue?vue&type=template&id=29636dd1&"
import script from "./PrenesiNalozenoDatoteko.vue?vue&type=script&lang=js&"
export * from "./PrenesiNalozenoDatoteko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports